module.exports = __webpack_public_path__ + "img/participant_p2.a68a149.png";